import React from 'react';

import { styled } from '@mui/material/styles';
import { Alert, Button } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactHookFormInput } from 'common/components/form/bootstrap';
import yupResolver from 'common/utils/yupResolver';

import validate from '../validate';

const LinkToLogin = styled('a')`
    color: #0047ba;

    &:hover {
        color: #0047ba;
        font-weight: bold;
        text-decoration: none;
    }
`;

const ResetPasswordForm = ({
    errors,
    initialValues,
    isLoadingSession,
    onChangePassword,
    onChangePasswordConfirmation,
    onSubmit,
    showRedirectLogin,
}) => {
    const { t } = useTranslation();

    const { control, handleSubmit, setValue, watch } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <ReactHookFormInput
                control={control}
                name="password"
                onChange={(e) => {
                    setValue('password', e.target.value);
                    onChangePassword(e);
                }}
                label={t('New password')}
                type="password"
            />

            <ReactHookFormInput
                control={control}
                name="confirm_password"
                onChange={(e) => {
                    setValue('confirm_password', e.target.value);
                    onChangePasswordConfirmation(e, watch());
                }}
                onFocus={(e) => onChangePasswordConfirmation(e, watch())}
                label={t('Confirm password')}
                type="password"
            />

            {errors &&
                errors.map((error, i) => (
                    <Alert severity="warning" key={`error-reset-${i}`}>
                        * {error}
                    </Alert>
                ))}

            {showRedirectLogin ? (
                <p>
                    {t('Your password has been reset')}.{' '}
                    <LinkToLogin href="/login">{t('Go to login')}</LinkToLogin>
                </p>
            ) : (
                <Button
                    disabled={isLoadingSession}
                    fullWidth
                    label={
                        isLoadingSession
                            ? t('Loading').concat('...')
                            : t('Restore password').toUpperCase()
                    }
                    type="submit"
                >
                    {isLoadingSession
                        ? t('Loading'.concat('...'))
                        : t('Restore password').toUpperCase()}
                </Button>
            )}
        </form>
    );
};

ResetPasswordForm.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    onChangePassword: PropTypes.func,
    onChangePasswordConfirmation: PropTypes.func,
    onSubmit: PropTypes.func,
    showRedirectLogin: PropTypes.bool,
};

export default ResetPasswordForm;
